// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".chips__btn_CPy36{color:var(--white);display:inline-flex;margin:0 0 0 .8rem}@media only screen and (min-width:1264px){.chips__btn_CPy36{margin:0 0 0 1rem}}.chips__btn_CPy36.is_boutique_UPsZF{--cp-secondary_main:var(--cp-tertiary_special-2)}.chips__btn_CPy36:hover *{fill:var(--cp-white)}.v-application--is-ltr .v-chip .v-chip__close.v-icon.v-icon--right{display:none;margin:0}.chips__facet_Cb1ha{align-items:center;display:flex}@media only screen and (min-width:1264px){.chips__facet_Cb1ha{flex-wrap:wrap}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chips__btn": "chips__btn_CPy36",
	"is_boutique": "is_boutique_UPsZF",
	"chips__facet": "chips__facet_Cb1ha"
};
module.exports = ___CSS_LOADER_EXPORT___;
